// extracted by mini-css-extract-plugin
module.exports = {"textPrimary":"var(--textPrimary)","ui2":"var(--ui2)","switch":"InstrumentalFilter_switch__MyACQ"};